import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
import en from './en/translation.json';
import no from './no/translation.json';
import my from './my/translation.json';
import zo from './zo/translation.json'; // Import Zopau translations

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        no: { translation: no },
        my: { translation: my },
        zo: { translation: zo }, // Add Zopau translations
    },
    lng: 'no', // Default language
    fallbackLng: 'no', // Fallback language
    interpolation: {
        escapeValue: false, // React already escapes values
    },
});

export default i18n;